var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWifiIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 21.032 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_8",
    "data-name": "Group 8",
    transform: "translate(-248.02 -296.326)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    "data-name": "Path 13",
    d: "M269.052,301.615a3.275,3.275,0,0,1-.282.536,1.2,1.2,0,0,1-1.718.18c-.437-.363-.842-.764-1.29-1.111a11.451,11.451,0,0,0-5.25-2.277,11.819,11.819,0,0,0-7.971,1.441,11.58,11.58,0,0,0-2.359,1.8,1.239,1.239,0,0,1-1.174.388,1.221,1.221,0,0,1-.6-2.08,14.389,14.389,0,0,1,18.836-1.231c.385.294.744.624,1.114.939a2.021,2.021,0,0,1,.7.961Z",
    fill: "#3fbbae"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    "data-name": "Path 14",
    d: "M312.56,376.038a9.909,9.909,0,0,1,6.7,2.927,1.2,1.2,0,0,1,.374,1.23,1.224,1.224,0,0,1-1.949.64c-.322-.265-.625-.554-.958-.8a7.474,7.474,0,0,0-4.3-1.527,7.611,7.611,0,0,0-5.576,2.016c-.117.105-.233.212-.355.311a1.225,1.225,0,0,1-1.642-.1,1.191,1.191,0,0,1-.048-1.639,9.207,9.207,0,0,1,2.5-1.876A10.661,10.661,0,0,1,312.56,376.038Z",
    transform: "translate(-53.56 -75.581)",
    fill: "#3fbbae"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15",
    "data-name": "Path 15",
    d: "M363.113,451.7a6.261,6.261,0,0,1,4.41,1.808,1.215,1.215,0,0,1,.07,1.717,1.2,1.2,0,0,1-1.7.1,4.353,4.353,0,0,0-1.573-.975,3.759,3.759,0,0,0-3.74.761,1.655,1.655,0,0,1-.856.49,1.221,1.221,0,0,1-1.03-2.091A6.266,6.266,0,0,1,363.113,451.7Z",
    transform: "translate(-104.579 -147.323)",
    fill: "#3fbbae"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16",
    "data-name": "Path 16",
    d: "M419.39,536.762a1.817,1.817,0,1,1-1.815-1.839A1.83,1.83,0,0,1,419.39,536.762Z",
    transform: "translate(-159.041 -226.231)",
    fill: "#3fbbae"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWifiIcon);
export default __webpack_public_path__ + "static/media/wifiIcon.0e78026a5831b5305e98a99ba7a97241.svg";
export { ForwardRef as ReactComponent };